/**
 * Generates a standardized name for persisted store state.
 *
 * This is used as the `name` property when configuring the `persist` middleware,
 * ensuring all persisted states are consistently prefixed.
 *
 * @param id - The unique identifier for the store.
 * @returns A string used for localStorage/sessionStorage keys.
 */
export const getPersistName = (id: string) => `consumer_portal:${id}`;
